var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "record-container" } },
    [
      _c(
        "div",
        { staticClass: "top-nav" },
        [
          _c("div", { staticClass: "button-box" }, [
            _c(
              "div",
              {
                staticClass: "back",
                on: {
                  click: function ($event) {
                    return _vm.$router.back()
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "el-icon-arrow-left",
                  staticStyle: { "margin-right": "3px" },
                }),
                _c("span", [_vm._v("返回")]),
              ]
            ),
            _c("span", { staticStyle: { "margin-right": "20px" } }, [
              _vm._v(_vm._s(_vm.exam.examName)),
            ]),
            _c("span", { staticStyle: { "margin-right": "20px" } }, [
              _vm._v(_vm._s(_vm.schoolName)),
            ]),
            _c("span", [_vm._v(_vm._s(_vm.exam.examCode))]),
          ]),
          _c(
            "el-radio-group",
            {
              attrs: { size: "mini", fill: "#d3e8ff", "text-color": "#409eff" },
              on: { change: _vm.handlePageTypeChange },
              model: {
                value: _vm.pageType,
                callback: function ($$v) {
                  _vm.pageType = $$v
                },
                expression: "pageType",
              },
            },
            [
              _c("el-radio-button", { attrs: { label: "切题" } }),
              _c("el-radio-button", { attrs: { label: "录题" } }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "button-box" },
            [
              _vm.exam.paperUrl
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "medium", type: "danger", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.paperUploadError(_vm.exam)
                        },
                      },
                    },
                    [_vm._v("试卷上传错误")]
                  )
                : _vm._e(),
              _c(
                "el-upload",
                {
                  staticStyle: { display: "inline", margin: "0 10px" },
                  attrs: {
                    action: "",
                    "http-request": _vm.uploadSectionFile,
                    "show-file-list": false,
                    accept: ".doc, .docx, .pdf",
                    "before-upload": _vm.beforeAction,
                    "on-error": _vm.handleError,
                  },
                },
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary", plain: "", size: "medium" } },
                    [_vm._v("上传或更新试题卷")]
                  ),
                ],
                1
              ),
              _vm.exam.paperUrl
                ? _c(
                    "el-button",
                    {
                      attrs: { plain: "", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm._downPaper(_vm.exam.paperUrl)
                        },
                      },
                    },
                    [_vm._v("下载试卷")]
                  )
                : [
                    _c(
                      "el-button",
                      {
                        attrs: { plain: "", size: "medium" },
                        on: {
                          click: function ($event) {
                            _vm.showEditPaper = !_vm.showEditPaper
                          },
                        },
                      },
                      [_vm._v("编辑试卷")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          plain: "",
                          size: "medium",
                          loading: _vm.submitLoading,
                        },
                        on: { click: _vm.save },
                      },
                      [_vm._v("保存录题")]
                    ),
                  ],
            ],
            2
          ),
        ],
        1
      ),
      _c("div", { staticClass: "record-container clearfix" }, [
        _c("div", { staticClass: "content" }, [
          _c(
            "div",
            {
              staticClass: "left-section-title",
              staticStyle: {
                "margin-bottom": "20px",
                "justify-content": "space-between",
              },
            },
            [
              _vm._m(0),
              _vm.exam.paperUrl
                ? _c(
                    "el-button",
                    {
                      staticStyle: { "flex-shrink": "0" },
                      attrs: { type: "primary", size: "mini" },
                      on: { click: _vm.handleToImg },
                    },
                    [
                      _c("img", {
                        staticStyle: {
                          "margin-right": "3px",
                          "vertical-align": "bottom",
                        },
                        attrs: {
                          src: require("images/transform.png"),
                          width: "14",
                          height: "14",
                        },
                      }),
                      _vm._v(" 转化为图片 "),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          !_vm.showEditPaper
            ? _c("div", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "tk_contain_upview",
                staticClass: "paper",
                attrs: {
                  id: "post-content",
                  "element-loading-text": "加载中...",
                },
                domProps: { innerHTML: _vm._s(_vm.contentHtml) },
                on: { mouseup: _vm.bindMouseUp, mousedown: _vm.bindMouseDown },
              })
            : _c(
                "div",
                { staticClass: "paper" },
                [
                  _c("vue-ckeditor", {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.loading,
                        expression: "loading",
                      },
                    ],
                    attrs: { types: "document", config: _vm.config1 },
                    model: {
                      value: _vm.contentHtml,
                      callback: function ($$v) {
                        _vm.contentHtml = $$v
                      },
                      expression: "contentHtml",
                    },
                  }),
                ],
                1
              ),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            ref: "qieti",
            staticClass: "inner",
          },
          [
            _c("h6", [_vm._v("题号列表")]),
            _vm.toSeverArr.length > 0
              ? _c(
                  "div",
                  { staticClass: "number addPaper-checkbox" },
                  [
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.formQuestionIds,
                          callback: function ($$v) {
                            _vm.formQuestionIds = $$v
                          },
                          expression: "formQuestionIds",
                        },
                      },
                      _vm._l(_vm.toSeverArr, function (item, index) {
                        return _c(
                          "el-checkbox",
                          {
                            key: index,
                            attrs: { label: item.standId, disabled: "" },
                          },
                          [
                            item.bigNum
                              ? _c("i", [_vm._v(_vm._s(item.bigNum) + ".")])
                              : _vm._e(),
                            _vm._v(" " + _vm._s(item.question) + " "),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _c("div", { staticClass: "number addPaper-checkbox no-data" }, [
                  _c("p", [_vm._v("试题卷还未上传，上传试题卷")]),
                ]),
          ]
        ),
      ]),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "试题属性",
            visible: _vm.editQuesShow,
            width: "1280px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.editQuesShow = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { staticClass: "form-wrapper", attrs: { "label-width": "50px" } },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 14 } }, [
                    _c(
                      "div",
                      { staticClass: "operate" },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "类型", id: "tumuortigan" } },
                          [
                            _c(
                              "el-radio-group",
                              {
                                model: {
                                  value: _vm.quesRel,
                                  callback: function ($$v) {
                                    _vm.quesRel = $$v
                                  },
                                  expression: "quesRel",
                                },
                              },
                              [
                                _c("el-radio", { attrs: { label: 1 } }, [
                                  _vm._v("题目"),
                                ]),
                                _c("el-radio", { attrs: { label: 2 } }, [
                                  _vm._v("公共题干"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.quesRel == 1,
                                expression: "quesRel == 1",
                              },
                            ],
                          },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { width: "550px" },
                                attrs: { label: "题型" },
                              },
                              [
                                _vm.isEdit
                                  ? _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.question.pattern.id,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.question.pattern,
                                              "id",
                                              $$v
                                            )
                                          },
                                          expression: "question.pattern.id",
                                        },
                                      },
                                      _vm._l(
                                        _vm.questionPatterns,
                                        function (item, index) {
                                          return _c(
                                            "el-radio",
                                            {
                                              key: index,
                                              attrs: { label: item.id },
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          )
                                        }
                                      ),
                                      1
                                    )
                                  : _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.question.pattern,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.question,
                                              "pattern",
                                              $$v
                                            )
                                          },
                                          expression: "question.pattern",
                                        },
                                      },
                                      _vm._l(
                                        _vm.questionPatterns,
                                        function (item, index) {
                                          return _c(
                                            "el-radio",
                                            {
                                              key: index,
                                              attrs: { label: item },
                                            },
                                            [_vm._v(_vm._s(item.name))]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                              ],
                              1
                            ),
                            _c("el-form-item", { attrs: { label: "题干" } }, [
                              _c(
                                "div",
                                { attrs: { id: "editor1" } },
                                [
                                  _c("vue-ckeditor", {
                                    attrs: {
                                      types: "inline",
                                      config: _vm.config,
                                    },
                                    model: {
                                      value: _vm.question.content,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.question, "content", $$v)
                                      },
                                      expression: "question.content",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm.question.pattern.type == 1
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "选项" } },
                                  [
                                    _c(
                                      "div",
                                      { attrs: { id: "editor1" } },
                                      _vm._l(
                                        _vm.question.options,
                                        function (itemm, index) {
                                          return _c(
                                            "div",
                                            {
                                              staticClass: "highLightFont",
                                              staticStyle: {
                                                "margin-left": "10px",
                                              },
                                              attrs: { id: "editor2" },
                                            },
                                            [
                                              index == 0
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "optionTitle",
                                                        },
                                                        [_vm._v("A.")]
                                                      ),
                                                      _c("vue-ckeditor", {
                                                        attrs: {
                                                          types: "inline",
                                                          config: _vm.config,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.question
                                                              .options[index],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.question
                                                                .options,
                                                              index,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "question.options[index]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              index == 1
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "optionTitle",
                                                        },
                                                        [_vm._v("B.")]
                                                      ),
                                                      _c("vue-ckeditor", {
                                                        attrs: {
                                                          types: "inline",
                                                          config: _vm.config,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.question
                                                              .options[index],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.question
                                                                .options,
                                                              index,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "question.options[index]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              index == 2
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "optionTitle",
                                                        },
                                                        [_vm._v("C.")]
                                                      ),
                                                      _c("vue-ckeditor", {
                                                        attrs: {
                                                          types: "inline",
                                                          config: _vm.config,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.question
                                                              .options[index],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.question
                                                                .options,
                                                              index,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "question.options[index]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              index == 3
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "optionTitle",
                                                        },
                                                        [_vm._v("D.")]
                                                      ),
                                                      _c("vue-ckeditor", {
                                                        attrs: {
                                                          types: "inline",
                                                          config: _vm.config,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.question
                                                              .options[index],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.question
                                                                .options,
                                                              index,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "question.options[index]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              index == 4
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "optionTitle",
                                                        },
                                                        [_vm._v("E.")]
                                                      ),
                                                      _c("vue-ckeditor", {
                                                        attrs: {
                                                          types: "inline",
                                                          config: _vm.config,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.question
                                                              .options[index],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.question
                                                                .options,
                                                              index,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "question.options[index]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              index == 5
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "optionTitle",
                                                        },
                                                        [_vm._v("F.")]
                                                      ),
                                                      _c("vue-ckeditor", {
                                                        attrs: {
                                                          types: "inline",
                                                          config: _vm.config,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.question
                                                              .options[index],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.question
                                                                .options,
                                                              index,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "question.options[index]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              index == 6
                                                ? _c(
                                                    "span",
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "optionTitle",
                                                        },
                                                        [_vm._v("G.")]
                                                      ),
                                                      _c("vue-ckeditor", {
                                                        attrs: {
                                                          types: "inline",
                                                          config: _vm.config,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.question
                                                              .options[index],
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.question
                                                                .options,
                                                              index,
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "question.options[index]",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          )
                                        }
                                      ),
                                      0
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-form-item",
                              { attrs: { label: "答案" } },
                              [
                                _vm.pattern.type == 1
                                  ? _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.question.answer,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.question,
                                              "answer",
                                              $$v
                                            )
                                          },
                                          expression: "question.answer",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "A" } },
                                          [_vm._v("A")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "B" } },
                                          [_vm._v("B")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "C" } },
                                          [_vm._v("C")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "D" } },
                                          [_vm._v("D")]
                                        ),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: "" } },
                                          [_vm._v("暂无")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      { attrs: { id: "editor2" } },
                                      [
                                        _c("vue-ckeditor", {
                                          attrs: {
                                            types: "inline",
                                            config: _vm.config,
                                          },
                                          model: {
                                            value: _vm.question.answer,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.question,
                                                "answer",
                                                $$v
                                              )
                                            },
                                            expression: "question.answer",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                            _c("el-form-item", { attrs: { label: "解析" } }, [
                              _c(
                                "div",
                                { attrs: { id: "editor2" } },
                                [
                                  _c("vue-ckeditor", {
                                    attrs: {
                                      types: "inline",
                                      config: _vm.config,
                                    },
                                    model: {
                                      value: _vm.question.analysis,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.question, "analysis", $$v)
                                      },
                                      expression: "question.analysis",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _c(
                              "el-form-item",
                              { attrs: { label: "知识点" } },
                              _vm._l(
                                _vm.question.points,
                                function (tag, index) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: index,
                                      attrs: {
                                        size: "small",
                                        closable: "",
                                        type: tag.type,
                                      },
                                    },
                                    [_vm._v(_vm._s(tag.name))]
                                  )
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.quesRel == 2,
                                expression: "quesRel == 2",
                              },
                            ],
                            staticClass: "question-title",
                          },
                          [
                            _c("el-form-item", { attrs: { label: "题干" } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    width: "300px",
                                    "margin-top": "6px",
                                  },
                                },
                                [
                                  _c("vue-ckeditor", {
                                    attrs: {
                                      types: "inline",
                                      config: _vm.config,
                                    },
                                    model: {
                                      value: _vm.topic.content,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.topic, "content", $$v)
                                      },
                                      expression: "topic.content",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                  _c("el-col", { attrs: { span: 10 } }, [
                    _c("div", { staticClass: "question-ids" }, [
                      _c("div", { staticClass: "inner" }, [
                        _c("h6", [_vm._v("题号列表")]),
                        _c(
                          "div",
                          { staticClass: "number addPaper-checkbox" },
                          [
                            _vm.quesRel == 1
                              ? _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: _vm.question.standId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.question, "standId", $$v)
                                      },
                                      expression: "question.standId",
                                    },
                                  },
                                  _vm._l(
                                    _vm.toSeverArr,
                                    function (item, index) {
                                      return _c(
                                        "el-radio",
                                        {
                                          key: index,
                                          attrs: { label: item.standId },
                                        },
                                        [
                                          item.bigNum
                                            ? _c("i", [
                                                _vm._v(
                                                  _vm._s(item.bigNum) + "."
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(
                                            " " + _vm._s(item.question) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                            _vm.quesRel == 2
                              ? _c(
                                  "el-checkbox-group",
                                  {
                                    model: {
                                      value: _vm.topic.standIds,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.topic, "standIds", $$v)
                                      },
                                      expression: "topic.standIds",
                                    },
                                  },
                                  _vm._l(
                                    _vm.toSeverArr,
                                    function (item, index) {
                                      return _c(
                                        "el-checkbox",
                                        {
                                          key: index,
                                          attrs: { label: item.standId },
                                        },
                                        [
                                          item.bigNum
                                            ? _c("i", [
                                                _vm._v(
                                                  _vm._s(item.bigNum) + "."
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(
                                            " " + _vm._s(item.question) + " "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                        _c(
                          "ul",
                          _vm._l(_vm.allPicUrl, function (item) {
                            return _c(
                              "li",
                              { staticStyle: { float: "left" } },
                              [
                                _c("img", {
                                  staticStyle: {
                                    "max-height": "200px",
                                    "max-width": "500px",
                                  },
                                  attrs: { src: item },
                                }),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("input", {
                staticClass: "input1",
                staticStyle: { height: "0", width: "0", border: "none" },
                attrs: { type: "text", id: "optionCount" },
              }),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.editQuesShow = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", autofocus: "autofocus" },
                  on: {
                    click: function ($event) {
                      return _vm.checkTopicInfo()
                    },
                  },
                },
                [_vm._v("保 存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "left-section-title",
        staticStyle: { "margin-right": "20px" },
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              "font-weight": "500",
              "font-size": "16px",
              "flex-shrink": "0",
            },
          },
          [_vm._v("WORD试题卷")]
        ),
        _c("img", {
          staticStyle: { margin: "0 10px" },
          attrs: {
            src: require("images/warning.svg"),
            alt: "",
            width: "20",
            height: "20",
          },
        }),
        _c("span", [
          _vm._v(
            "根据上传试卷的格式：WORD还是PDF采用不同的录题方式，WORD采用框选题干信息等识别题目，PDF采用切割试卷区域进行题目匹配；"
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }